import { useEffect, useState, useRef } from 'react'
import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import Sheet from '@mui/joy/Sheet'
import Box from '@mui/joy/Box'
import IconButton from '@mui/joy/IconButton'
import Remove from '@mui/icons-material/Remove'
import Add from '@mui/icons-material/Add'
import Input from '@mui/joy/Input'

const MinusButton = ({ onClick }) => (
    <IconButton variant="soft" onClick={onClick}>
        <Remove />
    </IconButton>
)

const AddButton = ({ onClick }) => (
    <IconButton variant="soft" onClick={onClick}>
        <Add />
    </IconButton>
)

const MIN = 1
const MAX = 800
const STEP = 1
export const FontSizeControl = ({ textObj, onChange }) => {
    const _toDisplaySize = ({ fontSize, scale }) => {
        return (fontSize * scale).toFixed(1)
    }

    const [fontSize, setFontSize] = useState(textObj.fontSize)
    const [scale, setScale] = useState(textObj.scaleX)
    const [displayFontSize, setDisplayFontSize] = useState(
        _toDisplaySize({ fontSize, scale })
    )

    useEffect(() => {
        textObj.on('scaling', handleTextScaling)
        return () => {
            textObj.off('scaling')
        }
    }, [textObj])

    const handleTextScaling = ({ transform }) => {
        setScale(transform.target.scaleX)
        setDisplayFontSize(
            _toDisplaySize({ fontSize, scale: transform.target.scaleX })
        )
    }

    const handleKeyDown = (e) => {
        // If ENTER key is pressed, trigger onChange
        // TODO: add number validation or block non-numbers from being entered
        if (e.keyCode == 13) {
            let value = e.target.value
            if (value < MIN || value > MAX) {
                return
            }
            let next = Number(e.target.value / scale)

            setFontSize(next)
            setDisplayFontSize(e.target.value)
            onChange(next)
        }
    }

    const handleInputChange = (e) => {
        if (e.target.value === '' || !isNaN(Number(e.target.value))) {
            setDisplayFontSize(e.target.value)
        }
    }

    const stepUp = () => {
        let target = fontSize * scale + STEP
        let next = target / scale
        console.log(target, next)
        if (next > MAX) {
            return
        }

        setFontSize(next)
        setDisplayFontSize(_toDisplaySize({ fontSize: next, scale }))
        onChange(next)
    }

    const stepDown = () => {
        let target = fontSize * scale - STEP
        let next = target / scale
        console.log(target, next)
        if (next < MIN) {
            return
        }

        setFontSize(next)
        setDisplayFontSize(_toDisplaySize({ fontSize: next, scale }))
        onChange(next)
    }

    return (
        <FormControl>
            <FormLabel>Font Size</FormLabel>
            <Sheet
                variant="outlined"
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1,
                    borderRadius: 6,
                }}
            >
                <MinusButton onClick={stepDown} />
                <Input
                    sx={{ width: 75 }}
                    variant="plain"
                    value={displayFontSize}
                    onKeyDown={handleKeyDown}
                    onChange={handleInputChange}
                />
                <AddButton onClick={stepUp} />
            </Sheet>
        </FormControl>
    )
}
